import moment from 'moment'

const QUARTERS = [
  { value: 1, label: '1 квартал' },
  { value: 2, label: '2 квартал' },
  { value: 3, label: '3 квартал' },
  { value: 4, label: '4 квартал' }
]

export function buildNdsPeriodOptions(options = {}) {
  const {
    now = moment(),
    yearsBack = 3,
    includeUnset = true
  } = options
  const current = moment(now)
  const currentYear = current.year()
  const currentQuarter = current.quarter()
  const periods = includeUnset ? [{ value: null, label: 'Не установлен' }] : []

  for (let offset = 0; offset <= yearsBack; offset += 1) {
    const year = currentYear - offset
    const maxQuarter = offset === 0 ? currentQuarter : 4

    QUARTERS.forEach((quarter) => {
      if (quarter.value <= maxQuarter) {
        periods.push({
          value: `${quarter.value}${year}`,
          label: `${quarter.label} ${year} года`
        })
      }
    })
  }

  return periods
}
